module.exports = __webpack_public_path__ + "img/2000_5e044a2ec3536.79785b2f.jpg";